import type { FC } from "react";

import { useTranslations } from "@ui/providers/useTranslations";

import { TruncatedTooltip } from "../TruncatedTooltip";

import styles from "./StickAttributes.module.scss";

type StickAttributeProps = { name: string; value: string };

export const StickAttribute: FC<StickAttributeProps> = ({ name, value }) => {
  const { __ } = useTranslations();

  return (
    <>
      <dt data-testid="attributeName">
        <TruncatedTooltip
          content={name}
          wrapperClassName={styles.attributeNameWrapper}
          iconClassName={styles.attributeNameIcon}
        >
          <div className={styles.attributeName}>{name}</div>
        </TruncatedTooltip>
      </dt>
      <dd data-testid="attributeValue" className={styles.attributeValue} data-value={value}>
        <span className={styles.attributeValueDot} aria-hidden="true"></span>
        <span className={styles.attributeValueDot} aria-hidden="true"></span>
        <span className={styles.attributeValueDot} aria-hidden="true"></span>
        <span className={styles.attributeValueDot} aria-hidden="true"></span>
        <span className={styles.attributeValueDot} aria-hidden="true"></span>

        <span className={styles.attributeValueHidden}>{__("stick_attribute.value_out_of_max", [value, 5])}</span>
      </dd>
    </>
  );
};
